import { Injectable, Signal, signal } from "@angular/core";

export type TQBreadCrumbs = Array<{ label: string, url?: string }>;


@Injectable({ providedIn: 'root' })
export class QBreadcrumbsService {
    private breadCrumbsSignal = signal<TQBreadCrumbs>([])
    constructor() {
    }

    public set breadCrumbs(val: TQBreadCrumbs) {
        this.breadCrumbsSignal.set(val);
    }

    public get breadCrumbs(): Signal<TQBreadCrumbs> {
        return this.breadCrumbsSignal.asReadonly();
    }


}
